import { RootState } from 'src/store';

import { IMerchant, IMerchantListData } from './types';

export const selectMerchantsData = (state: RootState): IMerchantListData => state.merchants.data;
export const selectMerchantsLoading = (state: RootState): boolean => state.merchants.isLoading;
export const selectMerchantsLoaded = (state: RootState): boolean => state.merchants.isLoaded;

export const selectMerchantDetails = (state: RootState): IMerchant | null => state.merchants.details;
export const selectMerchantDetailsLoaded = (state: RootState): boolean => state.merchants.detailsLoaded;
